import React from "react";
import styles from "./ReportKPICard.module.scss";

interface ReportKPICardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  trend?: {
    /** Yüzde değişim — negatif/pozitif */
    value: number;
    /** Trend olumluluğu: up=iyi, down=iyi, neutral */
    direction?: "up-good" | "down-good";
  };
  footnote?: string;
  accent?: "default" | "success" | "warning" | "danger";
}

const ReportKPICard: React.FC<ReportKPICardProps> = ({
  title,
  value,
  icon,
  trend,
  footnote,
  accent = "default",
}) => {
  const isPositiveTrend = trend
    ? trend.direction === "up-good"
      ? trend.value >= 0
      : trend.value <= 0
    : undefined;

  return (
    <div className={`${styles.card} ${styles[accent]}`}>
      <div className={styles.head}>
        <span className={styles.title}>{title}</span>
        {icon && <span className={styles.iconWrap}>{icon}</span>}
      </div>
      <div className={styles.value}>{value}</div>
      <div className={styles.foot}>
        {trend ? (
          <span
            className={`${styles.trend} ${isPositiveTrend ? styles.trendGood : styles.trendBad}`}
          >
            {trend.value >= 0 ? "▲" : "▼"} {Math.abs(trend.value).toFixed(1)}%
          </span>
        ) : (
          <span />
        )}
        {footnote && <span className={styles.footnote}>{footnote}</span>}
      </div>
    </div>
  );
};

export default ReportKPICard;
